export enum InHouseTaskNames {
    BONUS_REWARD = "Bonus Reward ",
    VERIFY_PHONE = "Verify Your Phone",
    DAILY_CHECK_IN = "Daily Check-In",
    COMPLETE_TUTORIAL = "Complete Tutorial",
    FOLLOW_US_TWITTER = "Follow Us on Twitter",
    LIKE_US_FACEBOOK = "Like Us on Facebook",
    SHARE_FACEBOOK = "Share on Facebook",
    SHARE_TWITTER = "Share on Twitter",
    SHARE_ACTIVITY = "Share Activity",
    SHARE_INSTAGRAM = "Share on Instagram",
    SHARE_WHATSAPP = "Share on WhatsApp",
    FOLLOW_US_INSTAGRAM = "Follow Us on Instagram",
    FOLLOW_US_TIKTOK = "Follow Us on TikTok",
    SHARE_MESSENGER = "Share on Messenger",
    ENTER_REFERRAL = "Enter Referral Code",
    INVITE_FRIENDS = "Invite Friends",
    FOLLOW_US_FACEBOOK = "Follow on Facebook",
    CUSTOMER_FEEDBACK = "Customer Feedback",
    SPIN_THE_WHEEL = "Spin The Wheel",
}
